import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import 'nvd3'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { RestServices } from '../../services/rest.services'
import { AuthService } from '../../services/auth.services'
import { SharedServices } from '../../services/shared.services'
import * as moment from 'moment'

declare let d3: any

@Component({
    selector: 'ons-page[tabCompliance]',
    templateUrl: './compliance.component.html',
    styleUrls: ['./compliance.component.css',
        '../../../../node_modules/nvd3/build/nv.d3.css'],
    encapsulation: ViewEncapsulation.None,
})
export class ComplianceComponent implements OnInit {
    options
    data
    optionsDevice
    dataDevice
    clientInfo
    clientId
    clientIdParam
    listCompliance
    arrayDataAligner = []
    arrayDataAligner2 = []
    arrayDataDevice = []
    arrayDataDevice2 = []
    averageTimeUsage = 0
    percentAverage = 0
    averageTimeUsageDevice = 0
    alignerId
    alignerInfo
    activeSegment = 0
    displayChartEffect = true

    constructor(private route: ActivatedRoute, private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices) {
        _sharedService.changeEmittedSource$.subscribe(
            success => {
                this.clientInfo = success[0]
                this.alignerId = this.clientInfo.activeAligner
                this.listCompliance = success[3]
                this.arrayDataAligner = []
                this.arrayDataAligner2 = []
                this.arrayDataDevice = []
                this.arrayDataDevice2 = []
                this.averageTimeUsage = 0
                this.percentAverage = 0
                this.averageTimeUsageDevice = 0
                if (this.listCompliance.length > 0) {
                    this.caculatorData()
                    this.caculatorDataDevice()
                }
                if (this.alignerId) {
                    let resultTest = success[1].find(aigner => aigner._id === this.alignerId)
                    this.alignerInfo = resultTest
                }
            },
        )
        this._sharedService.changeEmitted$.subscribe(
            res => {
                this.displayChartEffect = (res[0] === 'changePageMobileApp' || res[0] === 'changePageApp') && res[1] === 0
            })
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.clientId = id
            this.clientIdParam = '{"clientId":"' + [this.clientId] + '"}'
        })
        this.options = {
            chart: {
                type: 'discreteBarChart',
                height: 200,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 55,
                },
                yDomain: [0, 24],
                forceY: 5,
                x: function(d) {
                    return d.label
                },
                y: function(d) {
                    return d.value
                },
                showValues: false,
                duration: 500,
                xAxis: {},
                yAxis: {
                    ticks: 24,
                    tickFormat: function(d) {
                        if (parseFloat(d) % 6 == 0 || parseFloat(d) == 0) {
                            return parseFloat(d) + 'H'
                        }
                        return null
                    },
                },
                tooltip: {
                    contentGenerator: function(e) {
                        var series = e.series[0]
                        if (series.value === null) return

                        var rows =
                            '<tr>' +
                            '<td class=\'key\'>' + 'Usage' + '</td>' +
                            '<td class=\'x-value\'>' + (series.value ? parseFloat(series.value) + 'H' : 0 + 'H') + '</td>' +
                            '</tr>'

                        var header =
                            '<thead>' +
                            '<tr>' +
                            '<td class=\'key\'><strong>' + series.key + '</strong></td>' +
                            '</tr>' +
                            '</thead>'

                        return '<table>' +
                            header +
                            '<tbody>' +
                            rows +
                            '</tbody>' +
                            '</table>'
                    },
                },
            },
        }
        this.optionsDevice = {
            chart: {
                type: 'discreteBarChart',
                height: 200,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 55,
                },
                yDomain: [0, 100],
                forceY: 5,
                x: function(d) {
                    return d.label
                },
                y: function(d) {
                    return d.value
                },
                showValues: false,
                duration: 500,
                xAxis: {},
                yAxis: {
                    ticks: 6,
                    tickFormat: function(d) {
                        return parseFloat(d) + '%'
                    },
                },
                tooltip: {
                    contentGenerator: function(e) {
                        var series = e.series[0]
                        if (series.value === null) return

                        var rows =
                            '<tr>' +
                            '<td class=\'key\'>' + 'Usage' + '</td>' +
                            '<td class=\'x-value\'>' + (series.value ? parseFloat(series.value) + '%' : 0 + '%') + '</td>' +
                            '</tr>'

                        var header =
                            '<thead>' +
                            '<tr>' +
                            '<td class=\'key\'><strong>' + series.key + '</strong></td>' +
                            '</tr>' +
                            '</thead>'

                        return '<table>' +
                            header +
                            '<tbody>' +
                            rows +
                            '</tbody>' +
                            '</table>'
                    },
                },
            },
        }
    }

    caculatorData() {
        let totalTime = 0
        this.percentAverage = 0
        for (let i = 0; i < this.listCompliance.length; i++) {
            let time = moment(this.listCompliance[i].visitDate).format('DD MMM')
            let usage = 0
            if (this.listCompliance[i].usageTime) {
                usage = this.listCompliance[i].usageTime
            }
            this.arrayDataAligner.push(
                {
                    createTime: time,
                    usageTime: usage,
                },
            )
            totalTime = totalTime + usage
        }
        this.averageTimeUsage = parseFloat((totalTime / this.listCompliance.length).toFixed(1))
        let label = ''
        let value = 0

        for (let i = 0; i < this.arrayDataAligner.length; i++) {
            if (label != this.arrayDataAligner[i].visitDate) {
                this.arrayDataAligner2.push(
                    {
                        'label': label,
                        'value': value,
                        'color': '#00A0EA',
                    },
                )
                value = this.arrayDataAligner[i].usageTime
                label = this.arrayDataAligner[i].createTime
                if (this.arrayDataAligner.length === i + 1) {
                    this.arrayDataAligner2.push(
                        {
                            'label': label,
                            'value': value,
                            'color': '#00A0EA',
                        },
                    )
                }
            } else {
                if (value < this.arrayDataAligner[i].usageTime) {
                    value = this.arrayDataAligner[i].usageTime
                }
            }
        }
        let maxUsage = 24
        this.arrayDataAligner2.shift()
        // console.log(this.arrayDataAligner2);
        // for(let i =0;i<this.arrayDataAligner2.length;i++){
        //     if(this.arrayDataAligner2[i].value>maxUsage){
        //         maxUsage = this.arrayDataAligner2[i].value;
        //     }
        // }
        this.percentAverage = parseFloat(((this.averageTimeUsage / maxUsage) * 100).toFixed(2))
        this.data = [
            {
                values: this.arrayDataAligner2,
            },
        ]
    }

    caculatorDataDevice() {
        let raito = 0
        for (let i = 0; i < this.listCompliance.length; i++) {
            let time = moment(this.listCompliance[i].visitDate).format('DD MMM')
            let raitoUsage = this.listCompliance[i].accelerationRatio || 0
            this.arrayDataDevice.push(
                {
                    createTime: time,
                    raitoUsage: raitoUsage,
                },
            )
            raito = raito + raitoUsage
        }
        if ('orthoPulse' == this.clientInfo.accelationDevice) {
            this.averageTimeUsageDevice = Math.round(raito / this.listCompliance.length)
        }
        let label = ''
        let value = 0

        for (let i = 0; i < this.arrayDataDevice.length; i++) {
            if (label != this.arrayDataDevice[i].visitDate) {
                this.arrayDataDevice2.push(
                    {
                        'label': label,
                        'value': value,
                        'color': '#00A0EA',
                    },
                )
                value = this.arrayDataDevice[i].raitoUsage
                label = this.arrayDataDevice[i].createTime
                if (this.arrayDataDevice.length === i + 1) {
                    this.arrayDataDevice2.push(
                        {
                            'label': label,
                            'value': value,
                            'color': '#00A0EA',
                        },
                    )
                }
            } else {
                if (value < this.arrayDataDevice[i].raitoUsage) {
                    value = this.arrayDataDevice[i].raitoUsage
                }
            }
        }
        // let maxUsage = 0;
        this.arrayDataDevice2.shift()
        this.dataDevice = [
            {
                values: this.arrayDataDevice2,
            },
        ]
    }

    activeSegnment(id, segment) {
        this.activeSegment = id
        segment.setActiveButton(id)
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/compliance/compliance.component.ts